import { LegacyEngageInteractionTypeStatus } from '@/engage/types/interactions'

export default Object.freeze({
  DRAFT: LegacyEngageInteractionTypeStatus.DRAFT,
  SENDERROR: LegacyEngageInteractionTypeStatus.SENDERROR,
  SENT: LegacyEngageInteractionTypeStatus.SENT,
  COMPLETED: LegacyEngageInteractionTypeStatus.COMPLETED,
})
